export const OFF_DUTY = 'off-duty';
export const AVAILABLE = 'available';
export const SERVICING = 'servicing';

export const OFF_DUTY_COLOR = 'blue-grey lighten-4';
export const AVAILABLE_COLOR = 'green lighten-1';
export const SERVICING_COLOR = 'orange lighten-2';
